import { BirthdayDetailsFormType } from './BirthdayDetailsFormType';

export const createInitialValues = (): BirthdayDetailsFormType => ({
  day: 1,
  month: "01",
  name: "",
  email: "",
});
